// Copyright (c) 2016 Deere & Company
import { oktaCallback } from './routeStructure/oktacallback';
import { settings } from './routeStructure/settings';
import { unauthorizeerror } from './routeStructure/unauthorize';
import { welcome } from './routeStructure/welcome';

export const routes = [
    ...welcome,
    ...oktaCallback,
    ...settings,
    ...unauthorizeerror,
];
